export const DEAFUALT_LANGUAGE = 'en';
